import { get } from './requests'

export const getDayPeriods = key => get(['day-period'], { key })
